<template>
  <el-header :class="isCollapse ? 'el-header-no' : 'el-header'" style="height:3.125rem">
    <el-button type="primary" @click="toggleCollapse" :isCollapse="!isCollapse" style="
        background-color: #fff;
        border: 0;
        font-size: 1.1875rem;
        float: left;
        margin-left: -1.25rem;
      ">
      <i :class="{
          'el-icon-s-fold': !isCollapse,
          'el-icon-s-unfold': isCollapse,
        }" style="margin-top: 0.1875rem; color: #6f7374"></i>
    </el-button>

    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link" style="color: #6f7374; margin-right: 10px">
        <el-avatar class="el-jst-2">
          <img :src="userImg" />
        </el-avatar>
        <div class="el-jst-3">
          {{Name}}<i class="el-icon-arrow-down el-icon--right" style="color: #6f7374"></i>
        </div>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit" command="edit">
          修改密码</el-dropdown-item>
        <el-dropdown-item icon="el-icon-switch-button" command="quit">
          退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-button type="primary" @click="screen" style="
        background-color: #fff;
        border: 0;
        float: right;
        margin-right: 5px;
        margin-top: 6px;
        font-size: 18px;
      ">
      <i class="el-icon-full-screen" style="color: #6f7374"></i></el-button>
    <el-button style="
        background-color: #fff;
        border: 0;
        color: white;
        font-size: 18px;
        margin-left: -18px;
        float: left;
      ">
      <i class="el-icon-refresh-left" style="color: #6f7374; margin-top: 3px" @click="refresh"></i>
    </el-button>



    <div class="btn-bell">
      <el-popover placement="bottom" trigger="click">
        <el-table :data="gridData" @row-click="ToTZ">
          <el-table-column width="100" property="no_title" label="标题" show-overflow-tooltip ></el-table-column>
          <el-table-column width="200" property="yj_up_date" label="时间"></el-table-column>
        </el-table>
        <el-button type="text" slot="reference"><i class="el-icon-message" title="这是一条提示文字"></i></el-button>
      </el-popover>
    </div>
    <div class="btn-bell">
      <el-popover placement="bottom" trigger="click">
        <el-table :data="gridDataZG" @row-click="ToZG">
          <el-table-column width="100" property="tc_title" label="标题" show-overflow-tooltip></el-table-column>
          <el-table-column width="200" property="tc_wc_date" label="时间"></el-table-column>
        </el-table>
        <el-button type="text" slot="reference"><i class=" el-icon-message-solid" title="这是一条提示文字"></i></el-button>
      </el-popover>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialoHX" style="z-index: 999;">

      <el-form :model="formListAdd" ref="ruleForm">
        <el-form-item label="原始密码 :" label-width="120px">
          <el-input v-model="formListAdd.password"></el-input>
        </el-form-item>
        <el-form-item label="最新密码 :" label-width="120px">
          <el-input v-model="formListAdd.passwordNew"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="buttonNo()">取 消</el-button>
        <el-button type="primary" @click="buttonOk()">确 定</el-button>
      </div>
    </el-dialog>
  </el-header>

</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    computed: {
      ...mapState({
        current: state => state.tab.currentMenu
      }),
      isCollapse() {
        return this.$store.state.tab.isCollapse
      }
    },
    data() {
      return {
        formListAdd: {
          password: '',
          passwordNew: ''
        },
        dialoHX: false,
        userImg: require('../assets/img/20220127001.jpg'),
        message: 2,
        Name: '',
        gridData: [],
        gridDataZG: [],
      }
    },
    created() {},
    methods: {

      getGG() {
        var that = this
        var data = {
          'bm_status': localStorage.getItem('DeptStatus'),
          'bm_id': localStorage.getItem('Deptid'),
        }
        this.$axios({
          method: 'post',
          url: '/apiadmin/Home/index_xf',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.gridData = response.data.data
        })
      },
      getZG() {
        var that = this
        var data = {
          'bm_status': localStorage.getItem('DeptStatus'),
          'bm_id': localStorage.getItem('Deptid'),
        }
        this.$axios({
          method: 'post',
          url: '/apiadmin/Home/index_zg',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.gridDataZG = response.data.data
        })
      },
      toggleCollapse() {
        this.$store.commit('collapseMenu')
      },
      handleCommand(command) {
        var dataUser = {
          'yy': 4,
          'id': localStorage.getItem('id'),
        }
        var that = this
        this.$axios({
          method: 'post',
          url: '/apiadmin/user/users',
          data: dataUser,
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
        }).then(function(response) {
          console.log(response.data.data.password)
          that.formListAdd.password = response.data.data.password
        })

        switch (command) {
          case 'edit':
            // console.log('修改密码')
            this.dialoHX = true
            break;
          case 'quit':
            // console.log('退出登录')
            const token = localStorage.getItem('TOKEN')
            localStorage.removeItem('TOKEN')
            localStorage.removeItem('hangye')
            localStorage.removeItem('id')
            localStorage.removeItem('Deptid')
            localStorage.removeItem('DeptType')
            localStorage.removeItem('DeptStatus')
            localStorage.removeItem('DeptTitle')
            localStorage.removeItem('SessionId')
            localStorage.removeItem('showAuth')
            localStorage.removeItem('MM')
            localStorage.removeItem('token')
            localStorage.removeItem('username')
            localStorage.removeItem('visited')
            localStorage.removeItem('loginTime')
            sessionStorage.removeItem('session_active')
            this.$router.push('/')
            break;

          default:
            break;
        }
      },
      refresh() {
        location.reload();
      },
      screen() {
        let element = document.documentElement;
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
      buttonNo() {
        this.dialoHX = false
      },
      buttonOk() {
        var that = this
        var dataUser = {
          'yy': 3,
          'password': this.formListAdd.passwordNew,
          'id': localStorage.getItem('id'),
        }

        this.$axios({
          method: 'post',
          url: '/apiadmin/user/users',
          data: dataUser,
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
        }).then(function(response) {
          console.log(response.data.code)
          if (response.data.code == 200) {
            that.dialoHX = false
            that.$message.success(response.data.msg)
            location.reload();
          } else {
            that.$message.error(response.data.msg)
          }
        })
      },
      // 通知跳转
      ToTZ() {
        this.$router.push('/NoticeDowmEnter');
      },
      // 整改跳转
      ToZG() {
        this.$router.push('/downBack');
      }

    },
    created() {
      this.Name = localStorage.getItem('username')
      this.getGG()
      this.getZG()
    },

  }
</script>

<style>
  @import "../assets/css/index.less";
</style>



// WEBPACK FOOTER //
// src/components/Header.vue